import React from 'react';

import PropTypes from 'prop-types';
import jwt_decode from 'jwt-decode';
import { req } from 'react-reqq-lite';
import { useHistory } from 'react-router-dom';

import { useCheckToken } from 'modules/partial/hooks';

import { AUTHENTICATION } from '../constants';

function TokenWatcher({ children }) {
  const history = useHistory();

  useCheckToken((lastToken, newToken) => {
    if (!newToken && lastToken) {
      history.push('/logout');
      return;
    }
    const { user_type } = jwt_decode(newToken);
    const type =
      {
        branch_user: 'BRANCH',
        vendor: 'MERCHANT',
        admin: 'ADMIN',
        partner: 'PARTNER',
      }[user_type] || 'MERCHANT';

    if (newToken && lastToken && newToken !== lastToken) {
      req.cancelAll();
      req.clearCache();
      req.reset();
      window.location.reload();
      return;
    }

    if (newToken && user_type && !lastToken) {
      req.set(AUTHENTICATION, {
        isAuthenticated: true,
        type,
      });
    }
  });

  return <>{children}</>;
}
TokenWatcher.defaultProps = {};

TokenWatcher.propTypes = {
  children: PropTypes.instanceOf(Object).isRequired,
};

export default TokenWatcher;
